import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import 'handlebars';

const requireFromContext = (require: __WebpackModuleApi.RequireContext) => {
	require.keys().forEach(module => {
		require(module);
	});
};

// https://webpack.js.org/guides/dependency-management/#requirecontext
requireFromContext(require.context('../../lib', false, /\.js$/)); // Third-party files placed directly in the /lib folder
requireFromContext(require.context('../../app', true, /\.module.(ts|js)$/)); // AngularJS modules must be declared before the things they contain
requireFromContext(require.context('../../app', true, /\.(js|ts)$/));

import 'assets/js/SelectizePlugin-InfiniteScroll';
import { isLoggingEnabled, replaceConsoleLogging } from "ConsoleLogging";

if (environment.production) {
	enableProdMode();
}

replaceConsoleLogging(console, isLoggingEnabled(localStorage));

platformBrowserDynamic().bootstrapModule(AppModule);
